import Pubnub from 'pubnub';
import _ from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { ChannelMetaDataCustom } from '../../types';
import { getErrorText } from '../helpers';

type Response = Pubnub.SetChannelMetadataResponse<ChannelMetaDataCustom>;
type Params = {
  roomId: string;
  listenerId: string;
  name: string;
  messageTimeToken: string | number;
};

export const addListenerToAllowToSpeakList = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/addListenerToAllowToSpeakList',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;
      const { listenersAllowedToSpeak } = pubnubReducer;

      if (_.findIndex(listenersAllowedToSpeak, { id: data.listenerId }) >= 0) {
        throw new Error('ListenerAlreadyAllowedToSpeak');
      }

      const payload = [
        {
          id: data.listenerId,
          name: data.name,
          messageTimeToken: data.messageTimeToken,
        },
      ];

      if (pubnubReducer.pubnub) {
        const result = pubnubReducer.pubnub.objects.setChannelMetadata({
          channel: data.roomId,
          data: {
            custom: { listenersAllowedToSpeak: JSON.stringify(payload) },
          },
        });

        return result;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
